module.exports = __webpack_public_path__ + "img/oufu_130x160x12b.prt.8607db3a.jpg";